"use client";

import React from "react";
import { Select } from "./Form";
import useFilterContext from "../hooks/useFilterContext";

export const SORT_SEARCH_PARAM = "sort";

export interface SortBySelectProps {
  options: Array<{
    label: string;
    value: string;
  }>;
}

const SortBySelect: React.FC<SortBySelectProps> = ({ options }) => {
  const { formState, setFilterValues } = useFilterContext();
  const [value] = formState[SORT_SEARCH_PARAM] || [""];

  const onChange = (e) => {
    if (e.target.value) {
      setFilterValues(SORT_SEARCH_PARAM, [e.target.value]);
    } else {
      setFilterValues(SORT_SEARCH_PARAM, []);
    }
  };

  return (
    <div className="form-field-input-wrapper">
      <Select
        onChange={onChange}
        name={SORT_SEARCH_PARAM}
        options={options}
        value={value || ""}
      />
    </div>
  );
};

export default SortBySelect;
